import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { faHourglass } from '@fortawesome/free-regular-svg-icons'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import AppBadge from './app-badge'

function IssueBadge({ status, count }) {
  return (
    <>
      {status === 'No Issues' && (
        <AppBadge
          pill
          variant="success"
          className="text-center text-success fw-normal"
        >
          <FontAwesomeIcon icon={faCheck} className="me-1" />
          No Issues
        </AppBadge>
      )}
      {status === 'Pending' && (
        <AppBadge
          pill
          variant="warning"
          className="text-center text-warning fw-normal"
        >
          <FontAwesomeIcon icon={faHourglass} className="me-1" />
          Pending
        </AppBadge>
      )}
      {status === 'Unresolved' && (
        <AppBadge
          pill
          variant="danger"
          className="text-center text-danger high-risk fw-normal"
        >
          <FontAwesomeIcon icon={faExclamationCircle} className="me-1" />
          {count} Unresolved
        </AppBadge>
      )}
    </>
  )
}

export default IssueBadge
